import { createApp } from 'vue';
import GdprPrototypeApp from './vue/gdpr/GdprPrototypeApp.vue';
import type { GdprPrototypePayload } from './vue/gdpr/types';

document.addEventListener('DOMContentLoaded', () => {
    document.documentElement.classList.remove('nojs');

    const root = document.getElementById('gdpr-prototype-root');
    const payloadElement = document.getElementById('gdpr-prototype-data');

    if (!root || !payloadElement?.textContent) {
        return;
    }

    const payload = JSON.parse(payloadElement.textContent) as GdprPrototypePayload;
    createApp(GdprPrototypeApp, { payload }).mount(root);
});
